import { render } from "./FormRelManyProps.vue?vue&type=template&id=2e373c4c"
import script from "./FormRelManyProps.vue?vue&type=script&lang=js"
export * from "./FormRelManyProps.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyProps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e373c4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e373c4c', __exports__)) {
    console.log('reload')
    api.reload('2e373c4c', __exports__)
  }
  
  module.hot.accept("./FormRelManyProps.vue?vue&type=template&id=2e373c4c", () => {
    console.log('re-render')
    api.rerender('2e373c4c', render)
  })

}


export default __exports__